const COLOR_PROPERTIES = [
    'backgroundColor',
    'border',
    'borderColor',
    'borderTopColor',
    'borderBottomColor',
    'borderLeftColor',
    'borderRightColor',
    'borderInlineStartColor',
    'borderInlineEndColor',
    'color',
    'textShadow',
    'textDecorationColor',
    'boxShadow',
];
export class HostColorSelectorAPI {
    constructor(ps) {
        this.ps = ps;
    }
    selectColor(styleItemKey, context) {
        const propertyType = context.styleDefinitions?.cssProperties?.[styleItemKey]
            ? styleItemKey
            : context.styleDefinitions?.cssCustomProperties?.[styleItemKey]
                .cssPropertyType;
        if (!HostColorSelectorAPI.isColorProperty(propertyType)) {
            // TODO: throw error: unsupported property type https://wix.atlassian.net/browse/EP-6428
        }
        // feels bad
        const initialValue = context.styles?.cssProperties?.[styleItemKey] ??
            context.styles?.cssCustomProperties?.[styleItemKey];
        return new Promise((resolve) => {
            let value = initialValue;
            const onChange = (color) => {
                context.onChange(color);
                value = color;
            };
            const onApply = async (color) => {
                resolve(color);
            };
            void this.ps.hostAPI.editor.selectColor({
                initialValue,
                onApply,
                onChange,
                onClose: () => {
                    resolve(value);
                },
                onCancel: () => {
                    resolve(initialValue);
                },
                showBrand: true,
                showCustom: true,
                mode: ['solid'],
            });
        });
    }
}
HostColorSelectorAPI.isColorProperty = (property) => {
    return property ? COLOR_PROPERTIES.includes(property) : false;
};
//# sourceMappingURL=HostColorSelectorAPI.js.map